/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNamespace = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M21 3v2h-2V3zm-4 2V3h-2v2zm-4-2v2h-2V3zM9 5V3H7v2zM5 5V3H3v2zm16 4V7h-2v2zm0 2v2h-2v-2zm0 6v-2h-2v2zm0 2v2h-2v-2zm-4 2v-2h-2v2zm-4-2v2h-2v-2zm-4 2v-2H7v2zm-4-2v2H3v-2zm0-2v-2H3v2zm0-6v2H3v-2zm0-2V7H3v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNamespace as Namespace };
